import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {PaymentMethodStore} from "../../../State";
import {Messages} from "../../../Messages";
import {WalletButton} from "../../ui/WalletButton";
import {LoadingWidget} from "../../ui/LoadingWidget";
import {WalletPopup} from "../../ui/WalletPopup";
import {WidgetRoutes} from "../../WidgetRoutes";
import {WALLET_CARD_CONTENT_HEIGHT} from "../../WidgetConstants";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";
import {ChooseCard} from "../../../common/ChooseCard";
import {Router} from "../../../../stem-core/src/ui/Router";
import {WidgetCardItem} from "./components/WidgetCardItem";
import {WalletListItem} from "../../../common/WalletListItem";
import {apiSetPrimaryPaymentMethod} from "../../../../client/state/PaymentMethodStore";


class ElementStyle extends WalletCardStyle {
    @styleRuleInherit
    card = {
        padding: "24px 0",
        minHeight: 0,
    };

    @styleRuleInherit
    content = {
        display: "flex",
        flexDirection: "column",
        height: WALLET_CARD_CONTENT_HEIGHT,
        padding: "0 24px",
    };

    @styleRule
    chooseCardContainer = {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    };
}

@registerStyle(ElementStyle)
export class WidgetChooseCardClass extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.choosePaymentMethod,
        };
    }

    render() {
        const {styleSheet} = this;

        return <ChooseCard ref="chooseCard" className={styleSheet.chooseCardContainer}
                           hideActiveCard={true}
                           addNewCardColor={styleSheet.themeProps.WALLET_LINK}
                           CardItemClass={WidgetCardItem} ListItemClass={WalletListItem}
                           onAddCard={() => this.onAddCardClick()}
                           onCardSelected={() => this.redraw()}/>;
    }

    onAddCardClick() {
        Router.changeURL(WidgetRoutes.ADD_CARD)
    }

    renderPrimaryButton() {
        return <WalletButton onClick={() => this.onPrimaryButtonClick()} testId="chooseCardButton"
                             disabled={this.chooseCard?.getActive() === PaymentMethodStore.getPrimary()}>
            {Messages.confirmChooseCard}
        </WalletButton>;
    }

    onPrimaryButtonClick() {
        try {
            LoadingWidget.walletLoad(async () => apiSetPrimaryPaymentMethod(this.chooseCard.getActive()?.id) )
        } catch (error) {
            // TODO handle request error.
            console.error(error);
        } finally {
            this.discard();
        }
    }

    onMount() {
        super.onMount();

        this.attachListener(Dispatcher.Global, "widgetCardAdded", () => this.discard());
    }
}

export const WidgetChooseCard = WalletPopup(WidgetChooseCardClass);
